import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NavbarBrand, NavLink } from 'reactstrap';

import { onLinkClick } from './utils';

var NavigationBrand = function (_PureComponent) {
  _inherits(NavigationBrand, _PureComponent);

  function NavigationBrand(props) {
    _classCallCheck(this, NavigationBrand);

    var _this = _possibleConstructorReturn(this, (NavigationBrand.__proto__ || Object.getPrototypeOf(NavigationBrand)).call(this, props));

    _this.onBrandItemClick = function (evt) {
      onLinkClick(evt, function () {
        var _this$props = _this.props,
            onBrandItemClick = _this$props.onBrandItemClick,
            brandItem = _this$props.brandItem;

        onBrandItemClick(brandItem);
      });
    };

    return _this;
  }

  _createClass(NavigationBrand, [{
    key: 'render',
    value: function render() {
      var brandItem = this.props.brandItem;

      if (brandItem) {
        var _props = this.props,
            isBrandItemActive = _props.isBrandItemActive,
            formatItemPath = _props.formatItemPath;
        var path = brandItem.path,
            label = brandItem.label,
            icon = brandItem.icon,
            className = brandItem.className;


        var linkProps = {};
        if (isBrandItemActive) {
          linkProps.active = isBrandItemActive(brandItem);
        }
        if (path !== void 0) {
          linkProps.href = formatItemPath ? formatItemPath(path) : path;
        }

        return React.createElement(
          NavbarBrand,
          { tag: 'span' },
          React.createElement(
            NavLink,
            _extends({}, linkProps, { onClick: this.onBrandItemClick }),
            icon,
            label
          )
        );
      }
      return false;
    }
  }]);

  return NavigationBrand;
}(PureComponent);

NavigationBrand.propTypes = {
  brandItem: PropTypes.object,
  isBrandItemActive: PropTypes.func,
  onBrandItemClick: PropTypes.func,
  formatItemPath: PropTypes.func
};
export default NavigationBrand;